import { Modal, TextInput } from '@mantine/core';
import { Button } from 'components/atoms';
import renderIcon from 'icon';
import { getMadinaErrorMessage } from 'network/utils/madinaResponse';
import { v1postfundwallet } from 'network/services/wallet';
import { enqueueSnackbar } from 'notistack';
import React from 'react';
import { IoAddOutline } from 'react-icons/io5';
import { WALLET_FUND_REFERENCE_KEY } from 'utils/walletFund';

const FundMadinaWallet = () => {
  const [open, setOpen] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const ref = React.useRef<HTMLInputElement>(null);

  const commenceFund: React.FormEventHandler<HTMLFormElement> = async event => {
    event.preventDefault();
    const amount = Number(ref.current?.value);
    if (!Number.isFinite(amount) || amount < 100) {
      enqueueSnackbar('Minimum wallet top-up is 100', { variant: 'error' });
      return;
    }

    const callbackUrl = `${(process.env.REACT_APP_APPLICATION_DOMAIN || window.location.origin).replace(/\/$/, '')}/account/wallet`;
    setSubmitting(true);
    try {
      const body = await v1postfundwallet({ amount, callback_url: callbackUrl });
      const payload = body?.data ?? body;
      const authorizationUrl = payload?.authorization_url;
      const reference = payload?.reference;
      if (!authorizationUrl || !String(authorizationUrl).includes('onionpay') || !reference) {
        enqueueSnackbar(body?.message || 'Wallet funding did not open. Try again.', { variant: 'error' });
        return;
      }
      sessionStorage.setItem(WALLET_FUND_REFERENCE_KEY, String(reference));
      window.location.assign(authorizationUrl);
    } catch (error) {
      enqueueSnackbar(getMadinaErrorMessage(error), { variant: 'error' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <button onClick={() => setOpen(current => !current)} type="button" className="flex items-center gap-2 font-medium">
        <span>Fund Wallet</span>
        <span className="bg-primary p-2 rounded-full text-white">{renderIcon(IoAddOutline)}</span>
      </button>
      <Modal opened={open} onClose={() => setOpen(false)} centered radius="md">
        <form onSubmit={commenceFund}>
          <TextInput
            ref={ref}
            required
            label="Fund amount"
            title="Fund amount"
            placeholder="100.00"
            type="number"
            min={100}
            size="lg"
          />
          <span className="text-xs text-gray-500 mt-1 block">
            Minimum is 100. OnionPay confirms the payment before the balance changes.
          </span>
          <Button type="submit" className="mt-6" disabled={submitting} isLoading={submitting}>
            Fund Wallet
          </Button>
        </form>
      </Modal>
    </>
  );
};

export default FundMadinaWallet;
